import Index from "views/Index.js";
import Profile from "views/examples/Profile.js";
import StudioSchedule from "views/examples/StudioSchedule.js";
import Student from "views/examples/Student.js";
import Login from "views/examples/Login.js";
import Tables from "views/examples/Tables.js";
import Clients from "views/examples/Clients.js";
import ClassOverview from "./views/examples/ClassOverview";
import Teacher from "./views/examples/Teacher";
import Cabinet from "./views/examples/Cabinet";
import Register from "./views/examples/Register";
import RegisterF from "./views/examples/RegisterF";
import PasswordReset from "./views/examples/PasswordReset";
import Subscriptions from "./views/examples/Subscriptions";
import About from "./views/examples/About";
import PublicProfile from "./components/PublicProfile";

const routes = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: Index,
    layout: "/admin"
  },
  {
    path: "/user-profile",
    name: "Profile",
    icon: "ni ni-single-02 text-info",
    component: Profile,
    layout: "/admin"
  },
  {
    path: "/student-profile",
    name: "Client overview",
    icon: "ni ni-single-02 text-success",
    component: Student,
    layout: "/admin"
  },
  {
    path: "/teacher-profile",
    name: "Teacher overview",
    icon: "ni ni-single-02 text-secondary",
    component: Teacher,
    layout: "/admin"
  },
  {
    path: "/clients",
    name: "Clients",
    icon: "fas fa-users text-success",
    component: Clients,
    layout: "/admin"
  },
  {
    path: "/schedule",
    name: "Schedule",
    icon: "ni ni-calendar-grid-58 text-secondary",
    component: StudioSchedule,
    layout: "/admin"
  },
  {
    path: "/cabinet",
    name: "Cabinet",
    icon: "fas fa-laptop text-purple",
    component: Cabinet,
    layout: "/admin"
  },
  {
    path: "/tables",
    name: "Reports",
    icon: "ni ni-bullet-list-67 text-green",
    component: Tables,
    layout: "/admin"
  },
  {
    path: "/public-profile",
    name: "Client App",
    icon: "ni ni-world text-primary",
    component: PublicProfile,
    layout: "/admin"
  },
  {
    path: "/login",
    name: "Logout",
    icon: "fas fa-sign-out-alt text-white",
    component: Login,
    layout: "/auth"
  },
  {
    path: "/register",
    name: "Register",
    icon: "ni ni-key-25 text-red",
    component: RegisterF,
    layout: "/auth"
  },
  {
    path: "/password_reset",
    name: "Password reset",
    icon: "ni ni-key-25 text-red",
    component: PasswordReset,
    layout: "/auth"
  },
  {
    path: "/class_overview",
    name: "Class Overview",
    icon: "ni ni-bullet-list-67 text-red",
    component: ClassOverview,
    layout: "/admin"
  },
  {
    path: "user-profile/subscription",
    name: "Subscriptions_",
    icon: "ni ni-tv-2 text-primary",
    component: Profile,
    layout: "/admin"
  },
  {
    path: "/subscriptions",
    name: "Subscriptions",
    icon: "ni ni-bullet-list-67 text-red",
    component: Subscriptions,
    layout: "/admin"
  },
  {
    path: "/about",
    name: "Welcome",
    icon: "ni ni-bullet-list-67 text-primary",
    component: About,
    layout: "/admin"
  },
  {
    path: "admin/clients",
    name: "Clients_",
    icon: "ni ni-tv-2 text-primary",
    component: Clients,
    layout: "/admin"
  },
  {
    path: "*",
    name: "Dashboard_",
    icon: "ni ni-tv-2 text-primary",
    component: Index,
    layout: "/admin"
  },
  // {
  //   path: "/teachers/all",
  //   name: "Teachers",
  //   icon: "ni ni-tv-2 text-primary",
  //   component: Teachers,
  //   layout: "/teachers"
  // },
  // {
  //   path: "/register",
  //   name: "Register",
  //   icon: "ni ni-circle-08 text-pink",
  //   component: Register,
  //   layout: "/auth"
  // }
];
export default routes;
